import React from "react";
import MonkeyPaint from "../PaintModule/MonkeyPaint";
import { getFileExtension, getFileName, resolveFileUrl } from "./fileUtils";

const ThreeDFileViewer = ({ file, open, onClose, projectId }) => {
  const extension = getFileExtension(file);
  const fileName = getFileName(file);
  const modelUrl = resolveFileUrl(file, projectId);

  return (
    <MonkeyPaint
      onClose={onClose}
      modelUrl={modelUrl}
      fileName={fileName}
      extension={extension}
      fileMeta={file}
      open={open}
    />
  );
};

export default ThreeDFileViewer;
